import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
  Checkbox,
  Dropdown,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
  getWeekendShifts,
  getShiftList,
} from "redux/selectors";
import { utils, writeFileXLSX } from "xlsx";
import { CALL_API } from "common/API";
import { MONTH_LIST, STATUS_CODE } from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  isDateBetweenTwoDates,
  momentDate,
  numberOfDaysBetweenDates,
} from "utils/Date";
import COLORS from "common/Colors";
import {
  concat,
  find,
  get,
  includes,
  orderBy,
  flatMap,
  intersection,
  reduce,
  values,
} from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { SortAscendingOutlined } from "@ant-design/icons";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }

  .ant-form-item {
    display: inline-block;
  }

  .outer-form {
    margin-right: 0px;
  }

  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
    display: flex;
    align-items: center; /* ⭐ key */
  }

  /* Placeholder */
  .ant-select-selection-placeholder {
    color: #000 !important;
    font-weight: 400;
  }

  /* Arrow & clear icon */
  .ant-select-arrow,
  .ant-select-clear {
    top: 50% !important;
    transform: translateY(-50%);
  }

  /* Input / button alignment */
  .ant-input-affix-wrapper,
  .ant-input,
  .ant-btn {
    display: flex;
    align-items: center;
  }
`;

const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 768px) {
    margin-left: -40px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px !important;
  }
`;

function MonthlyAttendanceReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
  weekendShifts,
  shiftList,
}) {
  const higherOfficialsEmailId = userInfo?.higherOfficialsList?.map(
    (val) => val.email
  );
  console.log("userInfo?.higherOfficialsList", userInfo?.higherOfficialsList);
  console.log("higherOfficialsEmailId", higherOfficialsEmailId);
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [CSVAttendanceList, setCSVAttendanceList] = useState([]);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  var filterList = [];
  const [monthList, setMonthList] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const containerRef = useRef(null);
  const [activeSortColumn, setActiveSortColumn] = useState([]);
  const [uiTableData, setUITableData] = useState([]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setUITableData(extra.currentDataSource);
  };

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };
  const STAFF_LIST = React.useMemo(() => {
    const unique = new Map();
    userList.forEach((val) => {
      unique.set(val.userid, {
        value: val.userid,
        label: val.fullname,
      });
    });
    return Array.from(unique.values()).sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );
  }, [userList]);

  const filterattentancereport = attendanceList.filter((val) => {
    if (form.getFieldValue("staff_name") === "") {
      return val;
    } else if (val?.userid === form.getFieldValue("staff_name")) {
      return val;
    }
  });

  const [holidayList, setHolidayList] = useState([]);

  const calculateSundays = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    let sundays = 0;
    let currentDay = start.clone();

    while (currentDay.isSameOrBefore(end, "day")) {
      if (currentDay.day() === 0) {
        sundays++;
      }
      currentDay.add(1, "day");
    }

    return sundays;
  };

  // const workingdays = async (startDate, endDate, userId, holidayLists) => {
  //   const totalDay = numberOfDaysBetweenDates(startDate, endDate) + 1
  //   const filterUser = userList?.filter((val) => val?.userid === userId)
  //   const holidayPerUser = holidayLists?.filter((item) => item?.location_id?.includes(filterUser[0]?.baselocationid))
  //   let totalHolidays = 0;
  //   holidayPerUser.forEach(holiday => {
  //     const removeSundays = calculateSundays(holiday.start_date, holiday.end_date);
  //     totalHolidays += numberOfDaysBetweenDates(holiday.start_date, holiday.end_date) + 1 - removeSundays;
  //   });

  //   const sundayCount = calculateSundays(startDate, endDate);

  //   return totalDay - (sundayCount + totalHolidays)

  // };

  const workingdays = async (
    startDate,
    endDate,
    userId,
    holidayLists,
    assignedShiftList
  ) => {
    const filterUserShift = assignedShiftList?.filter(
      (item) => item?.userId === userId
    );
    const filterUser = userList?.filter((val) => val?.userid === userId);
    const holidayPerUser = holidayLists?.filter((item) =>
      item?.location_id?.includes(filterUser[0]?.baselocationid)
    );

    const filterShifts = filterUserShift.flatMap((shift) => shift?.dates);

    const count = filterShifts.filter((item) => {
      const date = moment(item.date, "YYYY-MM-DD");

      const isHoliday = find(holidayPerUser, ({ start_date, end_date }) =>
        isDateBetweenTwoDates(date, start_date, end_date)
      );

      const findShift = shiftList?.find(
        (val) => val?.shift_id === item?.shift_id
      );
      const weekend =
        (findShift?.isweekend === "allsaturdayandsunday" &&
          (moment(date).day() === 0 || moment(date).day() === 6)) ||
        (findShift?.isweekend === "allsaturdays" && moment(date).day() === 6) ||
        (findShift?.isweekend === "allsundays" && moment(date).day() === 0) ||
        findShift?.isweekend === "alldays" ||
        (isHoliday && findShift?.isholiday === "no");

      return (
        date.isSameOrAfter(startDate) &&
        date.isSameOrBefore(endDate) &&
        !weekend
      );
    }).length;

    return count;
  };

  // Helper function to calculate the number of Saturdays and Sundays between two dates
  const calculateWeekends = (start, end) => {
    let weekendCount = 0;
    const currentDate = new Date(start);
    const endDate = new Date(end);
    const isSaturdayNotApplicable =
      weekendShifts?.saturdayEnabled === false ||
      weekendShifts?.saturdayType === "NotApplicable";
    const isSundayNotApplicable =
      weekendShifts?.sundayEnabled === false ||
      weekendShifts?.sundayType === "NotApplicable";
    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
      if (isSaturdayNotApplicable && dayOfWeek === 6) {
        weekendCount++;
      } else if (isSundayNotApplicable && dayOfWeek === 0) {
        weekendCount++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return weekendCount;
  };

  const prepareCSV = async (event, done) => {
    const exportData = uiTableData.length
      ? uiTableData
      : filterattentancereport;
    if (exportData.length > 0) {
      setCSVList(
        reduce(
          exportData,
          (result, report) => {
            // Calculating total working days and worked days
            const workedDays =
              (Number(report.ontimecount) || 0) +
              (Number(report.latecount) || 0);

            const row = {
              "Employee ID": report.employeeid || "-",
              "User ID": report.userid || "-",
              Name: report.fullname || "-",
              "Total Working days": report.totalWorkingDays || "0",
              "Worked days": workedDays,
              "On-Time": report.ontimecount ?? "0",
              Late: report.latecount ?? "0",
              Leave: report.leavecount ?? "0",
              Absent: report.absentcount ?? "0",
              "Total worked Hours": report?.totalworkedduration || "00:00",
            };

            if (activeSortColumn.length > 0) {
              const filteredRow = {};
              columns.forEach((col) => {
                if (activeSortColumn.includes(col.dataIndex)) {
                  filteredRow[col.title] = row[col.title];
                }
              });
              result.push(filteredRow);
            } else {
              result.push(row);
            }

            return result;
          },
          []
        )
      );

      // Trigger download after setting CSV data
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error("No data available to download.");
    }
  };

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: 130,
    },
    {
      title: "User ID",
      dataIndex: "userid",
      key: "userid",
      width: 270,
      render: (userid) => {
        if (userid !== ("" || null || undefined)) {
          return userid;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 170,
      render: (fullname) => {
        if (fullname !== ("" || null || undefined)) {
          return fullname;
        } else {
          return "-";
        }
      },
    },

    {
      title: "Total Working days",
      dataIndex: "totalWorkingDays",
      key: "totalWorkingDays",
      width: 170,
    },
    {
      title: "Worked days",
      dataIndex: "workingDays",
      key: "workingDays",
      width: 150,
      render: (_, record) => {
        if (record.ontimecount || record.latecount) {
          return Number(record.ontimecount) + Number(record.latecount);
        } else {
          return 0;
        }
      },
    },

    {
      title: "On-Time",
      dataIndex: "ontimecount",
      key: "ontimecount",
      width: 100,
      render: (onTimeCount) => {
        if (onTimeCount === ("" || null || undefined)) {
          return "0";
        } else {
          return onTimeCount;
        }
      },
    },
    {
      title: "Late",
      dataIndex: "latecount",
      key: "latecount",
      width: 100,
      render: (lateCount) => {
        if (lateCount === ("" || null || undefined)) {
          return "0";
        } else {
          return lateCount;
        }
      },
    },

    {
      title: "Leave",
      dataIndex: "leavecount",
      key: "leavecount",
      width: 100,
      render: (leaveCount) => {
        if (leaveCount === ("" || null || undefined)) {
          return "0";
        } else {
          return leaveCount;
        }
      },
    },
    {
      title: "Absent",
      dataIndex: "absentcount",
      key: "absentcount",
      width: 100,
      render: (absentCount) => {
        if (absentCount === ("" || null || undefined)) {
          return "0";
        } else {
          return absentCount;
        }
      },
    },
    {
      title: "Total worked Hours",
      dataIndex: "totalworkedduration",
      key: "totalworkedduration",
      width: 100,
      render: (totalworkedduration) => {
        if (totalworkedduration === ("" || null || undefined)) {
          return "0";
        } else {
          return totalworkedduration;
        }
      },
    },
  ];

  const columnsWithSorting = columns.map((col) => ({
    ...col,
    sorter: activeSortColumn.includes(col.dataIndex)
      ? (a, b) => {
          const aVal = a[col.dataIndex];
          const bVal = b[col.dataIndex];

          // Date sort
          if (moment(aVal, moment.ISO_8601, true).isValid()) {
            return moment(aVal).valueOf() - moment(bVal).valueOf();
          }

          // String sort
          if (typeof aVal === "string") {
            return aVal.localeCompare(bVal);
          }

          // Number sort
          return (aVal ?? 0) - (bVal ?? 0);
        }
      : false,
  }));

  const SORT_OPTIONS = columns.map((col) => ({
    label: col.title,
    value: col.dataIndex,
  }));

  const finalColumns =
    activeSortColumn.length > 0
      ? columnsWithSorting.filter((col) =>
          activeSortColumn.includes(col.dataIndex)
        )
      : columnsWithSorting;

  const CSVHeaders =
    activeSortColumn.length > 0
      ? columns
          .filter((col) => activeSortColumn.includes(col.dataIndex))
          .map((col) => ({
            label: col.title,
            key: col.title,
          }))
      : [
          { label: "Employee ID", key: "Employee ID" },
          { label: "User ID", key: "User ID" },
          { label: "First Name", key: "First Name" },
          { label: "Last Name", key: "Last Name" },
          { label: "Total Working Days", key: "Total Working Days" },
          { label: "Worked days", key: "Worked days" },
          { label: "On-time", key: "On-time" },
          { label: "Late", key: "Late" },
          { label: "Leave", key: "Leave" },
          { label: "Absent", key: "Absent" },
        ];

  const sortMenu = (
    <div
      style={{
        padding: 12,
        width: 200,
        maxHeight: 300,
        overflowY: "scroll",
        background: "#fff",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
        fontWeight: 400,
      }}
    >
      <Checkbox.Group
        value={activeSortColumn}
        options={SORT_OPTIONS}
        onChange={(values) => setActiveSortColumn(values)}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      />
    </div>
  );

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);

  // Function to generate report
  const getAttendanceReport = async () => {
    list();
    setAttendanceList([]);
    const { month, department } = form.getFieldsValue();
    setDisplayTableLoader(true);

    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(find(MONTH_LIST, { value: month }), "index", 0)
    );

    const getAssignedShiftList = async () => {
      try {
        const { data } = await CALL_API(
          `get-assigned-shift/${ClientId}`,
          "post",
          {
            from: getMySqlDate(startDateOfMonth),
            to: getMySqlDate(lastDateOfMonth),
          }
        );
        return data || [];
      } catch (error) {
        console.log("[getAssignedShiftList] Error:", error);
        return [];
      }
    };

    const assignedShiftList = await getAssignedShiftList();

    const holidayLists = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: getMySqlDate(startDateOfMonth),
      end_date: getMySqlDate(lastDateOfMonth),
    });

    if (holidayLists) {
      setHolidayList(holidayLists);
    }

    const { code, monthlyAttendanceList, excludedUserList } = await CALL_API(
      `attendance-report-monthly/${ClientId}`,
      "post",
      {
        departmentId: [""],
        startDate: getMySqlDate(startDateOfMonth),
        endDate: getMySqlDate(lastDateOfMonth),
        reportingmanager: userInfo?.userid,
      }
    );
    if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
      const userIdExistsInData1 = (userId) => {
        if (!userId) return false; // Ensure userId is valid
        return monthlyAttendanceList?.some(
          (item) => item?.userid?.toLowerCase() === userId.toLowerCase()
        );
      };
      const allUserList = higherOfficialsEmailId?.includes(userInfo?.userid)
        ? userList?.filter((item) => {
            const userId = item?.userid?.toLowerCase();
            return (
              userId &&
              item?.statusid === "1" &&
              !userIdExistsInData1(userId) &&
              !excludedUserList?.includes(item?.userid) &&
              !higherOfficialsEmailId?.includes(userInfo?.userid)
            );
          })
        : userList
            ?.filter((item) => {
              const userId = item?.userid?.toLowerCase();
              return (
                userId &&
                item?.statusid === "1" &&
                !userIdExistsInData1(userId) &&
                item?.reportingmanager === userInfo?.userid &&
                !excludedUserList?.includes(item?.userid) &&
                !higherOfficialsEmailId?.includes(userInfo?.userid)
              );
            })
            .map((item) => ({
              employeeid: item?.employeeid,
              latecount: 0,
              monthenddate: getMySqlDate(lastDateOfMonth),
              leavecount: 0,
              userid: item?.userid,
              monthstartdate: getMySqlDate(startDateOfMonth),
              absentcount: 0,
              earlycheckoutcount: 0,
              fullname: item?.fullname,
              ontimecount: 0,
              totalworkedduration: "00:00",
            }));

      console.log("allUserList", allUserList);

      const monthlyAttendanceReport = concat(
        monthlyAttendanceList?.filter(
          (val) => !excludedUserList?.includes(val?.userid)
        ),
        allUserList
      );
      await Promise.all(
        monthlyAttendanceReport?.map(async (entry) => {
          const filterUser = userList?.filter(
            (val) => val?.userid === entry?.userId
          );
          const concatenatedArray = flatMap(filterUser[0]?.userdepartmentid);
          const totalWorkingDays = await workingdays(
            // moment(entry.monthstartdate)?.format("YYYY-MM-DD"),
            getMySqlDate(startDateOfMonth),
            // moment(entry.monthenddate)?.format("YYYY-MM-DD"),
            getMySqlDate(lastDateOfMonth),
            entry.userid,
            holidayLists,
            assignedShiftList
          );
          entry.totalWorkingDays = totalWorkingDays;
          if (
            intersection(concatenatedArray, selectedDepartmentId).length > 0
          ) {
            return entry;
          } else {
            return null;
          }
        })
      );

      // const updatedList = monthlyAttendanceReport?.map(entry => ({
      //   ...entry,
      //   date: new Date(entry.date),
      // }));
      setAttendanceList(monthlyAttendanceReport);
    }
    setDisplayTableLoader(false);
  };

  // Function to validate date range
  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "attendance-report.xlsx");
  });

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const calculateScrollY = () => {
      // const screenHeight = window.innerHeight;
      // const offset = 180; // Adjust this value as needed for headers/footers
      const dynamicHeight = window.innerHeight - 280;
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [scrollY]);

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(getKenyanDateTime()),
                end_date: momentDate(addDaysinDate(getKenyanDateTime(), 7)),
                department: "",
              }}
              onFinish={getAttendanceReport}
            >
              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select..."
                          options={monthList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.label === "All Employee" ||
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(a, b) => {
                    if (a?.label === "All Employee") return -1;
                    if (b?.label === "All Employee") return 1;
                    return (a?.label ?? "").localeCompare(b?.label ?? "");
                  }}
                  placeholder="Select Employee"
                  options={concat(
                    {
                      value: "",
                      label: "All Employee",
                    },
                    ...STAFF_LIST
                  )}
                  fieldNames={{
                    label: "label",
                    value: "value",
                  }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <div className="d-flex align-items-center gap-2">
            <Dropdown
              overlay={sortMenu}
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={() => containerRef.current}
            >
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  border: 0,
                }}
              >
                <SortAscendingOutlined />
              </Button>
            </Dropdown>
            <StyledButtonoutlined
              onClick={prepareCSV}
              disabled={filterattentancereport.length === 0}
            >
              Export CSV file
            </StyledButtonoutlined>
            <CSVLink
              header={CSVHeaders}
              data={CSVList}
              filename={"attendance-report.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </Col>
      </Row>
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={finalColumns}
          // Note : First parameter is Needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="employeeId"
          scroll={{ y: scrollY }}
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          id="Table"
          onChange={handleTableChange}
        />
      </Spin>
      {/* <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={columns}
          // Note : First parameter is Needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          id="Table"
        />
      </Spin> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  weekendShifts: getWeekendShifts(state),
  shiftList: getShiftList(state),
});

export default connect(mapStateToProps, null)(MonthlyAttendanceReport);
